import * as React from 'react';
import { connect } from 'react-redux';
import { assign } from '../../shared/Assign';
import { Translate } from '../../shared/LanguageService';
import { handleError } from '../../shared/ErrorCatching';
import LegalEntityForm from './LegalEntityForm';
import { Modal, Button } from 'react-bootstrap';
import { newLegalEntity, create, edit, update } from './Actions';
import ILegalEntityInput from './ILegalEntityInput';
import notify from '../../shared/feedback/notifications';

export class LegalEntityModal extends React.Component<any, any> {
    constructor(props: any) {
        super(props);

        this.state = {
            input: {
                organizationNumber: null,
                name: null,
                address: null,
                email: null,
                web: null,
                phonenumber: null,
                bgnr: null,
                accountingCountry: null
            },
            errors: {},
            creating: false,
            isLoading: true
        };

        this.save = this.save.bind(this);
        this.create = this.create.bind(this);
        this.update = this.update.bind(this);
        this.onChange = this.onChange.bind(this);
    }

    componentDidMount() {
        if (this.props.editId > 0) {
            this.props.actions
                .edit(this.props.editId)
                .then(() => {
                    let props = this.props;
                    this.setState({
                        input: assign({}, this.props.input),
                        isLoading: false
                    });
                })
                .catch((error: any) =>
                    handleError(error, (message: string): void => {
                        notify.failure(message);
                        this.setState({ isLoading: false });
                    })
                );
        } else {
            this.props.actions
                .new()
                .then(() => {
                    let input = this.state.input;
                    input.accountingCountry = this.props.availableCountries[0].id;
                    this.setState({
                        input: assign({}, input),
                        isLoading: false
                    });
                })
                .catch((error: any) =>
                    handleError(error, (message: string): void => {
                        notify.failure(message);
                        this.setState({ isLoading: false });
                    })
                );
        }
    }

    onChange(e: any): void {
        let input = this.state.input;
        const value = e.target.value;

        input[e.target.name] = value === '' ? null : value;

        this.setState({ input: assign({}, input) });
    }

    save(): void {
        this.setState({ creating: true });
        if (this.props.editId === -1) {
            this.create();
        } else {
            this.update();
        }
    }

    create(): void {
        this.props.actions
            .create(this.state.input)
            .then(() => {
                notify.success(Translate('legalentities/notification/legal-entity-added'));
                this.setState({ creating: false });
                this.props.closeModal();
            })
            .catch((error: any) =>
                handleError(error, (errors: any): void => {
                    this.setState({ errors: errors, creating: false });
                })
            );
    }

    update(): void {
        this.props.actions
            .update(this.state.input, this.props.editId)
            .then(() => {
                notify.success(Translate('legalentities/notification/legal-entity-updated'));
                this.setState({ creating: false });
                this.props.closeModal();
            })
            .catch((error: any) =>
                handleError(error, (errors: any): void => {
                    this.setState({ errors: errors, creating: false });
                })
            );
    }

    render() {
        return (
            <div>
                <Modal show={this.props.shouldShowModal} onHide={this.props.closeModal}>
                    <Modal.Header closeButton>
                        <Modal.Title>
                            {this.props.editId > 0
                                ? Translate('legalentities/modal/title/edit-legal-entity')
                                : Translate('legalentities/modal/title/add-legal-entity')}
                        </Modal.Title>
                    </Modal.Header>
                    <Modal.Body>
                        {!this.state.isLoading && (
                            <LegalEntityForm
                                input={this.state.input}
                                onChange={this.onChange}
                                errors={this.state.errors}
                                isEdit={this.props.editId !== -1}
                                availableCountries={this.props.availableCountries}
                            />
                        )}
                    </Modal.Body>
                    <Modal.Footer>
                        <Button onClick={this.props.closeModal}>
                            {Translate('legalentities/modal/footer-button/close')}
                        </Button>
                        <Button
                            disabled={this.state.creating}
                            bsStyle="primary"
                            onClick={this.save}
                        >
                            {Translate('legalentities/modal/footer-button/save')}
                        </Button>
                    </Modal.Footer>
                </Modal>
            </div>
        );
    }
}

function mapStateToProps(state: any, ownProps: any): any {
    return {
        input: state.legalEntities.edit,
        availableCountries: state.legalEntities.availableCountries
    };
}

function mapDispatchToProps(dispatch: any): any {
    return {
        actions: {
            new: () => dispatch(newLegalEntity()),
            create: (input: ILegalEntityInput) => dispatch(create(input)),
            edit: (id: number) => dispatch(edit(id)),
            update: (legalEntity: ILegalEntityInput, id: number) =>
                dispatch(update(legalEntity, id))
        }
    };
}

export default connect(mapStateToProps, mapDispatchToProps)(LegalEntityModal);
